/**
 * Client-side env helpers.
 *
 * `isDevelopment()` reads `process.env.NODE_ENV` baked into the client bundle
 * by rspack's DefinePlugin (via `rspack/common/env.js`). In real deployments
 * the build is invoked with `NODE_ENV=production`, so prod and preview both
 * resolve to `false`. Mirrors the server-side helper at `src/server/lib/env.ts`.
 *
 * **Local prod-variant preview** — the dev server always bundles with
 * `NODE_ENV=development` (rspack mode and react-refresh both depend on it).
 * To preview the prod variant locally, run a real production build:
 *
 *   yarn nx run prototype-playground:start-optimized
 *
 * (Don't try `NODE_ENV=production yarn nx start` — that breaks react-refresh
 * with `$RefreshSig$ is not defined`.)
 */

export const isDevelopment = (): boolean =>
  process.env.NODE_ENV === "development";
